import { render, staticRenderFns } from "./UnauthorizedContainer.vue?vue&type=template&id=268275de"
import script from "./UnauthorizedContainer.vue?vue&type=script&lang=js"
export * from "./UnauthorizedContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports